import { Button, Drawer, Form, Select } from "antd";
import { useEffect } from "react";
import { md_warehouse_mapping } from "../warehouse_selection_drawer";

const { Option } = Select;

interface UnifiedReceiveDrawerProps {
  visible: boolean;
  onFinish: (values: { chosen_warehouse_id: number }) => void;
  onClose: () => void;
}

const UnifiedReceiveDrawer = ({
  visible,
  onFinish,
  onClose,
}: UnifiedReceiveDrawerProps) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      form.resetFields();
    }
  }, [visible, form]);

  const onSubmit = () => {
    form.validateFields().then((values) => {
      onFinish(values);
    });
  };

  return (
    <Drawer
      title="Receive — Select Warehouse"
      placement="right"
      open={visible}
      closable={true}
      onClose={onClose}
      width={400}
      footer={
        <div className="d-flex gap-2">
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={onSubmit}>
            Proceed
          </Button>
        </div>
      }
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="chosen_warehouse_id"
          label="Receive at Warehouse"
          rules={[{ required: true, message: "Please select a warehouse" }]}
        >
          <Select placeholder="Select a warehouse">
            {md_warehouse_mapping.map((w) => (
              <Option key={w.id} value={w.id}>
                {w.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default UnifiedReceiveDrawer;
